"use client";

import { useEffect, useRef } from "react";

import { StoredPaywallContext, trackPaywallHit } from "@/lib/analytics";

type PaywallTrackerProps = {
  trigger: "daily_limit_reached" | "duration_limit_hit" | "premium_feature_clicked";
  feature?: string;
  linksUsedToday?: number;
  linksRemaining?: number;
  userId?: string;
  onTracked?: (context: StoredPaywallContext) => void;
};

export default function PaywallTracker({ trigger, feature, linksUsedToday, linksRemaining, userId, onTracked }: PaywallTrackerProps) {
  const hasTrackedRef = useRef(false);

  useEffect(() => {
    if (hasTrackedRef.current) return;

    const context = trackPaywallHit(trigger, {
      feature,
      links_used_today: linksUsedToday,
      links_remaining: linksRemaining,
      user_id: userId,
    });
    onTracked?.(context);
    hasTrackedRef.current = true;
  }, [feature, linksRemaining, linksUsedToday, onTracked, trigger, userId]);

  return null;
}
